export const CACHE_TIME = 5 * 60 * 1000; // 5 minutes

export const MAX_CHAT_HISTORY_LENGTH = 100;

export const MAX_DIFF_AGE = 1000 * 60 * 60 * 24 * 3; // 3 days
